import { useEffect, useState } from "react";
import { addCategoriesBlogForm, updateCategoriesBlogForm } from "../../lib/actions";
import DropDown from "../../components/GDropDownList/DropDown";
import { useNavigate, useParams } from "react-router-dom";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";

export default function EditCategoiresBlogUi({categoryByIdData, positionOfCategoiresBlog, statusOfCategoriesBlog }) {

    const {categoryBlogId} = useParams();
    const nav = useNavigate();
    const [isHome, setIsHome] = useState(null);
    const [isActive, setIsActive] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    useEffect(() => {
        setIsHome(categoryByIdData.isHome === true ? "1" : "0");
        setIsActive(categoryByIdData.active === true ? "1" : "0");
    }, [])

    const onchange = (e) => {
        setIsHome(e);
    };

    const onchange2 = (e) => {
        setIsActive(e);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const result = await updateCategoriesBlogForm(categoryBlogId, new FormData(e.target), navigate);
        setLoading(false);
    };

    const navigate = (route) => {
        nav(route);
    };

    if ( Object.entries(categoryByIdData).length < 1) {
        return <div className="flex justify-center items-center h-[25rem]"><ThreeDot variant="bounce" color="#D06421" size="large" text="" textColor="" /></div> 
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1  md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "position" : "الموضع"}</label>
                    <DropDown options={positionOfCategoiresBlog} value={isHome} onchange={onchange} defaultText={currentLang === "en" ? "enter position of category" : "اختر موضع الفئة "} paramkey="isHome" />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "status" : "الحالة"}</label>
                    <DropDown options={statusOfCategoriesBlog} value={isActive} onchange={onchange2} defaultText={currentLang === "en" ? "enter status of category" : "اختر حالة الفئة "} paramkey="active" />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "name in arabic" : "الاسم باللغة العربية "} </label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData?.name?.ar}
                        name="name_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in arabic" : "أدخل الاسم باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "name in english" : "الاسم باللغة الانجيليزية "}</label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData?.name?.en}
                        name="name_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter name in english" : " أدخل الاسم باللغة الانجليزية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2"> {currentLang === "en" ? "description in arabic" : "الوصف باللغة العربية "} </label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData?.description?.ar}
                        name="description_ar"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter description in arabic" : "أدخل الوصف باللغة العربية "}
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-white mb-2">{currentLang === "en" ? "description in english" : "الوصف باللغة الانجليزية "} </label>
                    <input
                        type="text"
                        defaultValue={categoryByIdData?.description?.en}
                        name="description_en"
                        className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
                        required
                        placeholder={currentLang === "en" ? "enter description in english" : "أدخل الوصف باللغة الانجليزية "}
                    />
                </div>
            </div>
            <div className="flex justify-center w-full mt-5">
                <button type="submit" disabled={loading} className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary" }`} >
                    {loading ? (
                        <>
                            <svg
                                className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" ></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                            </svg>
                        </>
                    ) : (
                        t("button.save")
                    )}
                </button>
            </div>
        </form>
    );
};